import {Component, OnDestroy, OnInit} from '@angular/core';
import {ITEMS_PER_PAGE} from '../../../shared/constants';
import {ICurrency} from '../../../shared/model';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {NzModalService} from 'ng-zorro-antd/modal';
import {EventManager} from '../../../core/services';
import {CurrencyService} from '../currency.service';
import {HttpHeaders, HttpResponse} from '@angular/common/http';
import {CurrencyUpdateComponent} from '../currency-update/currency-update.component';

@Component({
  selector: 'app-currency',
  templateUrl: './currency.component.html',
  styleUrls: ['./currency.component.scss']
})
export class CurrencyComponent implements OnInit, OnDestroy {
  currencies?: ICurrency[];
  eventSubscriber?: Subscription;
  // Pagination
  page!: number;
  predicate!: string;
  ascending!: boolean;
  totalItems = 0;
  size = ITEMS_PER_PAGE;
  search: any;
  ngbPaginationPage = 1;

  constructor(
    protected currencyService: CurrencyService,
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    public modalService: NzModalService,
    private eventManager: EventManager,
  ) {
  }

  ngOnInit(): void {
    this.activatedRoute.data.subscribe(data => {
      this.page = data.pagingParams.page;
      this.ascending = data.pagingParams.ascending;
      this.predicate = data.pagingParams.predicate;
      this.ngbPaginationPage = data.pagingParams.page;
      this.loadPage();
    });
    this.registerChangeInCurrency();
  }

  protected onSuccess(data: ICurrency[] | null, headers: HttpHeaders, page: number): void {
    this.totalItems = Number(headers.get('X-Total-Count'));
    this.page = page;
    this.currencies = data || [];
  }

  ngOnDestroy(): void {
    if (this.eventSubscriber) {
      this.eventManager.destroy(this.eventSubscriber);
    }
  }

  registerChangeInCurrency(): void {
    this.eventSubscriber = this.eventManager.subscribe('currencyListModification', () => this.loadPage());
  }

  trackId(index: number, item: ICurrency): number {
    return item.id;
  }

  private sort(): string[] {
    const result = [this.predicate + ',' + (this.ascending ? 'asc' : 'desc')];
    if (this.predicate !== 'id') {
      result.push('id');
    }
    return result;
  }

  buildCurrencyModal(currency?: ICurrency): void {
    let title = 'Add Currency';
    if (currency) {
      title = 'Update Currency';
    }
    const modal = this.modalService.create({
      nzTitle: title,
      nzWidth: '650px',
      nzStyle: {top: '20px'},
      nzContent: CurrencyUpdateComponent,
      nzData: {currency}
    });
  }

  confirmDelete(currencyId: number) {
    this.currencyService.delete(currencyId).subscribe(rs => {
      this.loadPage();
    });
  }

  cancelDelete() {
    // todo
  }

  loadPage(page?: number): void {
    const pageToLoad: number = page || this.page;

    this.currencyService
      .query({
        page: pageToLoad - 1,
        size: this.size,
        sort: this.sort()
      })
      .subscribe(
        (res: HttpResponse<ICurrency[]>) => this.onSuccess(res.body, res.headers, pageToLoad),
        () => this.onError()
      );
  }

  protected onError(): void {
    this.ngbPaginationPage = this.page;
  }
}
